import { AccountsService } from 'base/accounts_service';
import { AccountStore } from 'base/account_store';
import { navigateInternal } from 'base/navigation';
import { AvatarGroup } from 'base/ui/avatar_group';
import { Button } from 'base/ui/button';
import { IconAddSmall } from 'base/ui/icons';
import { Inline } from 'base/ui/layout';
import { ManageTeamModel } from 'blocks/manage_account/manage_team_model';
import { manageAccountRouteToUrl } from 'blocks/manage_account/routes';
import React, { useEffect, useMemo, useState } from 'react';

interface Props {
  accountStore: AccountStore;
  accountsService: AccountsService;
}

export function TeamActions({ accountStore, accountsService }: Props) {
  const [manageTeamModel, setManageTeamModel] = useState<ManageTeamModel>();

  useEffect(() => {
    void accountsService
      .getTeam()
      .then((res) =>
        setManageTeamModel(new ManageTeamModel(res, accountsService)),
      );
  }, [accountsService]);

  const teamMembers = useMemo(
    () =>
      manageTeamModel?.members.map((member) => ({
        id: member.id,
        color: member.color,
        user: member,
        self: member.isMe,
      })) ?? [],
    [manageTeamModel?.members],
  );

  if (accountStore.member == null || manageTeamModel == null) {
    return null;
  }

  const showAdminActions = accountStore.member.role === 'admin';

  return (
    <Inline xalign="start" yalign="center">
      <AvatarGroup
        avatars={teamMembers}
        background="grey"
        maxVisible={10}
        overlap
      />
      {showAdminActions && (
        <Inline spacing={8}>
          <Button
            variant="secondary"
            background="grey3"
            href={manageAccountRouteToUrl({
              path: 'manage-account/team',
              showInviteNewUsers: true,
            })}
            onClick={navigateInternal}
            label="Invite"
            icon={IconAddSmall}
          />
          <Button
            variant="secondary"
            background="grey3"
            href={manageAccountRouteToUrl({ path: 'manage-account/team' })}
            onClick={navigateInternal}
            label="Manage team"
          />
        </Inline>
      )}
    </Inline>
  );
}
